import { PropagateLoader } from "react-spinners";
import logo from "../assets/navbar/logolg.webp";

const Loader = () => {
  return (
    <div
      className="customLoaderContainer"
      role="status"
      aria-live="polite"
    >
      {/* <div className='imgBox'> */}
      <img className="logo" src={logo} alt="ICFC Finance Limited" />
      {/* </div> */}

      <PropagateLoader
        className="loader"
        size={16}
        color="#02033F"
        loading
        aria-hidden="true"
      />
      <span className="a11y-sr-only">Loading, please wait…</span>
    </div>
  );
};

export default Loader;
